var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCode(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 22,
    viewBox: "0 0 27 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.4231 15C26.0178 15 26.5 15.4822 26.5 16.0769V20.9231C26.5 21.5178 26.0178 22 25.4231 22H20.5769C19.9822 22 19.5 21.5178 19.5 20.9231C19.5 20.3283 19.9822 19.8462 20.5769 19.8462C22.6586 19.8462 24.3462 18.1586 24.3462 16.0769C24.3462 15.4822 24.8283 15 25.4231 15Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.5 1.07692C0.5 0.482155 0.982155 0 1.57692 0H6.42308C7.01785 0 7.5 0.482155 7.5 1.07692C7.5 1.67169 7.01785 2.15385 6.42308 2.15385C4.34139 2.15385 2.65385 3.84139 2.65385 5.92308C2.65385 6.51785 2.17169 7 1.57692 7C0.982155 7 0.5 6.51785 0.5 5.92308V1.07692Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.57692 15C2.17169 15 2.65385 15.4822 2.65385 16.0769C2.65385 18.1586 4.34139 19.8462 6.42308 19.8462C7.01785 19.8462 7.5 20.3283 7.5 20.9231C7.5 21.5178 7.01785 22 6.42308 22H1.57692C0.982155 22 0.5 21.5178 0.5 20.9231V16.0769C0.5 15.4822 0.982155 15 1.57692 15Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.5 1.07692C19.5 0.482155 19.9822 0 20.5769 0H25.4231C26.0178 0 26.5 0.482155 26.5 1.07692V5.92308C26.5 6.51785 26.0178 7 25.4231 7C24.8283 7 24.3462 6.51785 24.3462 5.92308C24.3462 3.84139 22.6586 2.15385 20.5769 2.15385C19.9822 2.15385 19.5 1.67169 19.5 1.07692Z",
    fill: "currentColor"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.5 11C5.5 10.4477 5.94772 10 6.5 10H20.5C21.0523 10 21.5 10.4477 21.5 11C21.5 11.5523 21.0523 12 20.5 12H6.5C5.94772 12 5.5 11.5523 5.5 11Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCode);
export default __webpack_public_path__ + "static/media/code.93f5e43b4b687eb2ae06a029ecc44511.svg";
export { ForwardRef as ReactComponent };